export default {"src":"/_next/static/media/moreOptionIconsc.5562bdd7.svg","height":15,"width":25};